import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { clearAuth, LOGIN_PATH } from "../api/auth";
import mockqLogo from "../images/mockq-logo-dark.png"; // blue MockQ logo (transparent background)

const BEGINNER_NAV_ITEMS = [
  {
    to: "/beginner/profile",
    label: "Profile",
    tag: "B1",
    icon: "bi-person-circle",
  },
  {
    to: "/beginner/practice",
    label: "Practice Exams",
    tag: "B2",
    icon: "bi-journal-check",
  },
  {
    to: "/beginner/main-exam",
    label: "Main Exam",
    tag: "B3",
    icon: "bi-file-earmark-text",
  },
  {
    to: "/beginner/subscription",
    label: "Subscription",
    tag: "B4",
    icon: "bi-credit-card",
  },
  {
    to: "/beginner/results",
    label: "Results",
    tag: "B5",
    icon: "bi-award",
  },
];

export default function BeginnerSidebar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuth();
    setMenuOpen(false);
    navigate(LOGIN_PATH, { replace: true });
  };

  return (
    <aside
      className={`oes-home-sidenav beginner-sidenav ${
        menuOpen ? "beginner-menu-open" : ""
      }`}
    >
      <div className="beginner-mobile-header">
        <div className="oes-home-brand oes-home-brand-has-logo">
          <Link
  to="/beginner/dashboard"
  className="oes-home-brand-link"
  aria-label="MockQ beginner student home"
  onClick={() => setMenuOpen(false)}
>
            <img
              src={mockqLogo}
              alt="MockQ"
              className="oes-home-brand-logo"
              draggable="false"
            />
          </Link>
          <div className="oes-home-brand-text">
            <small>Beginner Student Portal</small>
          </div>
        </div>

        <button
          type="button"
          className="beginner-menu-toggle"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-controls="beginner-navigation"
          aria-label={
            menuOpen ? "Close navigation menu" : "Open navigation menu"
          }
        >
          <i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"}`} />
          <span>{menuOpen ? "Close" : "Menu"}</span>
        </button>
      </div>

      <nav
        id="beginner-navigation"
        className="beginner-navigation"
        aria-label="Beginner student navigation"
      >
        {BEGINNER_NAV_ITEMS.map((item) => (
          <NavLink
            to={item.to}
            key={item.to}
            title={item.label}
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              `oes-home-navitem${isActive ? " active" : ""}`
            }
          >
            <span className="oes-home-navitem-icon">
              <i className={`bi ${item.icon}`} />
            </span>

            <span className="oes-home-navitem-text">{item.label}</span>

            <span className="oes-home-navitem-label">{item.tag}</span>
          </NavLink>
        ))}
      </nav>

      <div className="beginner-sidebar-footer">
        <button
          type="button"
          className="beginner-logout-btn"
          onClick={handleLogout}
        >
          <i className="bi bi-box-arrow-right" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}